function getDOMBreadcrumbs(eventName, ref) {
  const nodeNames = [eventName];

  if (ref.current) {
    let node = ref.current;

    while (node) {
      nodeNames.unshift(node?.dataset?.eventtrackingnodename);

      node = node.parentNode;
    }
  }

  return nodeNames.filter(v => !!v).join(' > ');
}

export default getDOMBreadcrumbs;
